/**
 * Menu - A molecule component for menu containers.
 *
 * Provides styling and structure for menu items.
 * Used within Dropdown components.
 */

import { type ReactNode } from 'react';
import { cn } from '@lean-agility/design-system/react';

export interface MenuProps {
  /**
   * Menu content (typically MenuItem components).
   */
  children: ReactNode;
  /**
   * Width of the menu.
   */
  width?: 'sm' | 'md' | 'lg' | 'xl' | 'auto';
  /**
   * Additional CSS classes.
   */
  className?: string;
}

const widthClasses = {
  sm: 'w-48',
  md: 'w-56',
  lg: 'w-64',
  xl: 'w-72',
  auto: 'w-auto',
};

export function Menu({ children, width = 'md', className }: MenuProps) {
  return (
    <div
      className={cn(
        `
          border border-border-default bg-bg-elevated
          dark:border-border-default dark:bg-bg-elevated
        `,
        'z-50 overflow-hidden rounded-lg shadow-lg',
        widthClasses[width],
        className,
      )}
    >
      {children}
    </div>
  );
}
